export const yellow = '#FFF04B';
export const navy = '#00234B';
export const white = '#FFFFFF';
export const black = '#000000';
export const blueLink = '#2BBFED';
export const coral = '#FF6473';

export const green = '#00E6AF';
export const green75 = '#40ECC3';
export const green50 = '#80F3D7';
export const green25 = '#BFF9EB';
export const green10 = '#E6FDF7';

export const blue = '#28D7FA';
export const blue75 = '#5EE1FB';
export const blue50 = '#94EBFD';
export const blue25 = '#C9F5FE';
export const blue10 = '#EAFBFF';

export const purple = '#C382FF';
export const purple75 = '#D2A1FF';
export const purple50 = '#E1C1FF';
export const purple25 = '#F0E0FF';
export const purple10 = '#F9F3FF';

export const pink = '#FFB4C8';
export const pink75 = '#FFC7D6';
export const pink50 = '#FFDAE4';
export const pink25 = '#FFECF1';
export const pink10 = '#FFF8FA';

export const grey = '#878791';
export const grey75 = '#A5A5AD';
export const grey50 = '#C3C3C8';
export const grey25 = '#E1E1E4';
export const grey10 = '#F3F3F4';
